module.exports = __webpack_public_path__ + "img/millier.9776fbec.png";